import { render, staticRenderFns } from "./invoiceTemplate.vue?vue&type=template&id=774a48c8&scoped=true"
import script from "./invoiceTemplate.vue?vue&type=script&lang=js"
export * from "./invoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./invoiceTemplate.vue?vue&type=style&index=0&id=774a48c8&prod&scoped=true&lang=css"
import style1 from "./invoiceTemplate.vue?vue&type=style&index=1&id=774a48c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a48c8",
  null
  
)

export default component.exports